import { getCountryNameByCode, formatPrice } from '@SHARED/js/helpers/misc';
import store from '../../store/store';
import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './OrderSummaryComponent.html';

export default {
  template,

  mixins: [CdnMixin],

  data() {
    return {
      sharedState: store, // Do not modify this directly – this is only for convenience in templates.
    };
  },

  methods: {
    getCountryNameByCode,
    formatPrice,
  },
};
